import React from 'react';

import { Anchor, Box } from '@zillow/constellation';

// Matches homerecs carousels large card width: https://gitlab.zgtools.net/zillow/discover-experience/home-recs-carousels/-/blob/1ca8f45102080dd3f2a0561af183107ecc154067/src/utilities/constants.ts#L15
const CARD_SIZE = 345;

export const JumpBackInCardWrapper = ({
    href,
    gated,
    children,
}: React.PropsWithChildren<{ href?: string; gated?: boolean }>) => {
    const asLinkProps = href
        ? {
              as: Anchor,
              href,
          }
        : {};

    return (
        <Box
            {...asLinkProps}
            sx={{
                'display': 'block',
                'minWidth': `${CARD_SIZE}px`,
                'maxWidth': `${CARD_SIZE}px`,
                'borderRadius': '$PropertyCard.cardBody.borderRadius',
                'padding': '$spacing.sm',
                // override default Constellation's Anchor styles
                'textDecoration': 'none !important',
                'boxShadow': '$shadows.shadow100 !important',
                '&:hover': {
                    boxShadow: '$shadows.shadow200 !important',
                },
                // to contain dismiss icon
                'position': 'relative',
                ...(gated
                    ? {
                          pointerEvents: 'none',
                          userSelect: 'none',
                      }
                    : {}),
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'min-content 1fr min-content',
                    gap: '$spacing.sm',
                    alignItems: 'center',
                    height: '100%',
                    ...(gated
                        ? {
                              filter: 'blur(4px)',
                          }
                        : {}),
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
JumpBackInCardWrapper.defaultProps = {
    href: undefined,
    gated: false,
};
